import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { ADELPHI_STATEMENTS_DEFAULT_STATE } from './constants';

const completedState = completeState(ADELPHI_STATEMENTS_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [
    actions.GET_ALL_STATEMENTS,
    actions.CREATE_ADELPHI_STATEMENT,
    actions.GET_STATEMENT_BY_ID,
    actions.GENERATE_STATEMENT_CSV_BY_ID,
    actions.DELETE_STATEMENT_BY_ID
  ],
  override: {
    [actions.SET_CURRENT_ADELPHI_STATEMENT]: onReadValue()
  }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
